import Home from '../../components/home'
const index = () => {
  return <Home />
}

export default index
